@if (!errorType) {
<tec-pwcs-layout
    [ngClass]="{ dark: designService.isDarkMode()}"
    [title]="tutorial ? '' : 'CONNECTIONS.TYPES.WORKLIFE' | translate"
    [subtitle]="subtitle"
    [footerLabel]="tutorial ? ('GENERAL.TUTORIAL_CONNECTION_ENCRYPTION' | translate) : ''">

    <tec-progress [value]="progressService.getValue()"></tec-progress>

    <ng-container content>
        @if (tutorial) {
            <pwcs-inline-svg
                [src]="'assets/images/connection-tutorial' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                idSuffix="work-life-connection-tutorial"
            />
        } @else {
            <!-- PHASE 1 -->
            @if (!mode_otp) {
                <tec-tile [formGroup]="form">
                    <div class="grid grid-e2">
                        @if (!hasOcrOperation) {
                            <tec-form-group [label]="'CONNECTIONS.WORK_LIFE.FORM.ID' | translate"
                                [errorMsg]="reactiveFormService.hasMsgError(form.get('nif'))">
                                <tec-input formControlName="nif" [hasError]="reactiveFormService.hasError(form.get('nif'))"></tec-input>
                            </tec-form-group>
                            <tec-form-group [label]="'CONNECTIONS.WORK_LIFE.FORM.BIRTH_DATE' | translate"
                                [errorMsg]="reactiveFormService.hasMsgError(form.get('birthdate'))">
                                <tec-datepicker
                                    formControlName="birthdate"
                                    placeholder="DD/MM/YYYY"
                                    [hasError]="reactiveFormService.hasError(form.get('birthdate'))"
                                    type="input"
                                ></tec-datepicker>
                            </tec-form-group>
                        }
                        <div>
                            <tec-form-group
                                [label]="'CONNECTIONS.WORK_LIFE.FORM.PHONE' | translate"
                                [tooltip]="'CONNECTIONS.WORK_LIFE.FORM.PHONE_TOOLTIP' | translate"
                                [errorMsg]="reactiveFormService.hasMsgError(form.get('phone'))">
                                <!-- TODO: [NIF-519] Sustituir por phone-input de Infinity cuando esté adaptado -->
                                <app-phone-input
                                    formControlName="phone"
                                    [hasError]="reactiveFormService.hasError(form.get('phone'))"
                                />
                            </tec-form-group>
                        </div>
                    </div>
                </tec-tile>
                <ng-container [ngTemplateOutlet]="manualLink"></ng-container>
            }
            <!-- PHASE 2 -->
            @if (mode_otp) {
                <tec-tile>
                    <tec-code-input
                        [errorMsg]="codeOtpError"
                        (formValue)="codeOtpError = ''; codeOtp = $event"
                    ></tec-code-input>
                    <span style="display: ruby; align-self: center;">
                        {{ 'CONNECTIONS.WORK_LIFE.SMS_NOT_RECEIVED' | translate }} <tec-link (click)="sendForm()">{{ 'CONNECTIONS.WORK_LIFE.SMS_RESEND' | translate }}</tec-link>
                    </span>
                </tec-tile>
                <ng-container [ngTemplateOutlet]="manualLink"></ng-container>
            }
        }
    </ng-container>
    <ng-container actions>
        @if (tutorial) {
            <tec-button
                size="lg"
                [label]="'GENERAL.BUTTON.CONTINUE' | translate"
                (clickEvent)="finishTutorial()"
            ></tec-button>
        } @else {
            <!-- PHASE 1 -->
            @if (!mode_otp) {
                <tec-button
                    size="lg"
                    [label]="'GENERAL.BUTTON.GET_CODE' | translate"
                    (clickEvent)="sendForm()"
                ></tec-button>
            }
            <!-- PHASE 2 -->
            @if (mode_otp) {
                <tec-button
                    size="lg"
                    [label]="'GENERAL.BUTTON.CONTINUE' | translate"
                    (clickEvent)="sendOtpCode()"
                ></tec-button>
            }
        }
    </ng-container>

    <!-- NAV HELP -->
    <tec-nav-help
        [elements]="tutorial ? navsHelpTutorial : navsHelp"
        (clickEvent)="navHelpChange($event)"
    ></tec-nav-help>
</tec-pwcs-layout>
}

<!-- ERRORS -->
@if (errorType) {
<tec-pwcs-layout [ngClass]="{ dark: designService.isDarkMode()}">
    <ng-container content>
        @switch (errorType) {
            @case ('phone-not-found') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.WORK_LIFE.ERROR.PHONE_NOT_PHONE_TITLE' | translate"
                    [subtitle]="operation.config?.numberOfTries < operation.config?.total_tries ? ('CONNECTIONS.WORK_LIFE.ERROR.PHONE_NOT_PHONE_DESCRIPTION' | translate) : ('CONNECTIONS.WORK_LIFE.ERROR.PHONE_NOT_PHONE_DESCRIPTION_2' | translate)"
                    tagIconStatus="default"
                    icon="icon-alert">
                    <ng-container [ngTemplateOutlet]="helpLink"></ng-container>
                </tec-tile>
            }
            @case ('robot') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.WORK_LIFE.ERROR.ROBOT_TITLE' | translate"
                    [subtitle]="operation.config?.numberOfTries < operation.config?.total_tries ? ('CONNECTIONS.WORK_LIFE.ERROR.ROBOT_DESCRIPTION' | translate) : ('CONNECTIONS.WORK_LIFE.ERROR.ROBOT_DESCRIPTION_2' | translate)"
                    tagIconStatus="default"
                    icon="icon-alert">
                    <ng-container [ngTemplateOutlet]="helpLink"></ng-container>
                </tec-tile>
            }
            @case ('insufficient-data') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.WORK_LIFE.ERROR.INSUFFICIENT_DATA_TITLE' | translate"
                    [subtitle]="'CONNECTIONS.WORK_LIFE.ERROR.INSUFFICIENT_DATA_DESCRIPTION' | translate"
                    tagIconStatus="default"
                    icon="icon-alert"
                ></tec-tile>
            }
            @case ('server') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.WORK_LIFE.ERROR.SERVER_TITLE' | translate"
                    [subtitle]="'CONNECTIONS.WORK_LIFE.ERROR.SERVER_DESCRIPTION' | translate"
                    tagIconStatus="default"
                    icon="icon-alert"
                ></tec-tile>
            }
        }
    </ng-container>
    <ng-container actions>
        @if (errorType === 'phone-not-found' || errorType === 'robot') {
            @if (operation.config?.numberOfTries < operation.config?.total_tries) {
                <tec-button
                    [type]="operation.config?.['fallback']?.['type'] !== MODE.MANUAL ? 'default' : 'secondary'"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.GO_BACK' | translate"
                    (clickEvent)="errorType = null"
                ></tec-button>
            }
            @if (operation.config?.['fallback']?.['type'] === MODE.MANUAL) {
                <tec-button
                    [type]="'default'"
                    icon="icon-paperclip"
                    iconPosition="left"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.ATTACH' | translate"
                    (clickEvent)="errorType = null; changeToManualUpload()"
                ></tec-button>
            }
        }
    </ng-container>
</tec-pwcs-layout>
}

<ng-template #manualLink>
    @if (operation.config?.['fallback']?.['type'] === MODE.MANUAL) {
    <span style="display: ruby;">
        {{ 'GENERAL.PREFER' | translate }} <tec-link (click)="changeToManualUpload()">{{ 'CONNECTIONS.WORK_LIFE.ADD_MANUALLY' | translate }}</tec-link>
    </span>
    }
</ng-template>

<ng-template #helpLink>
    <span >
        <tec-link (click)="isVisibleHelp = true">{{ 'GENERAL.BUTTON.GET_HELP' | translate }}</tec-link>
    </span>
</ng-template>

<app-modal-scan-qr
    [ngClass]="{'dark': designService.isDarkMode()}"
    [(isVisible)]="isVisibleScan"
    [url]="auth.getQRUrl()"
></app-modal-scan-qr>

<app-modal-work-life-help
    [ngClass]="{'dark': designService.isDarkMode()}"
    [(isVisible)]="isVisibleHelp"
></app-modal-work-life-help>
